import { render } from "./InputDate.vue?vue&type=template&id=bff0d8ce"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__